import React from 'react';
import type { Message } from '../types';
import DiligenceArtifactCard from './DiligenceArtifactCard';
import { getMessageArtifacts } from '../utils/documentUiState';

export default function DiligenceArtifactList({ message, onDownload }: {
  message: Pick<Message, 'artifact' | 'artifacts'>;
  onDownload?: (artifactId: string, fileName: string) => Promise<void>;
}) {
  const artifacts = getMessageArtifacts(message);
  if (!artifacts.length) return null;
  return <div className="max-w-full space-y-3" aria-label={artifacts.length > 1 ? 'Documentos generados' : undefined}>
    {artifacts.map(artifact => <DiligenceArtifactCard key={artifact.id} artifact={artifact} onDownload={onDownload} />)}
  </div>;
}
